import { createListenerMiddleware, type Dispatch } from "@reduxjs/toolkit";

import {
  flushAction,
  type NautilusStateAction,
  redoAction,
  revertAction,
  sendServerActionCompleted,
  undoAction,
} from "../nautilusActions.ts";
import type { NautilusDesignerState } from "../nautilusState.ts";
import type { ServerAction } from "../serverActions.ts";

export interface UnsentActionsStorageOptions {
  saveUnsentActions: (actions: ServerAction[]) => void;
  clearUnsentActions: () => void;
}

export const unsentActionsStorageListenerCreate = ({
  saveUnsentActions,
  clearUnsentActions,
}: UnsentActionsStorageOptions) => {
  const listener = createListenerMiddleware<NautilusDesignerState, Dispatch<NautilusStateAction>>();
  listener.startListening({
    predicate: (action) =>
      flushAction.match(action) ||
      undoAction.match(action) ||
      redoAction.match(action) ||
      sendServerActionCompleted.match(action) ||
      revertAction.match(action),
    effect: (_action, { getState }) => {
      const { unsentServerActions } = getState().server;
      if (unsentServerActions.length === 0) {
        clearUnsentActions();
      } else {
        saveUnsentActions(unsentServerActions);
      }
    },
  });
  return listener;
};
